import React from 'react';
import { Link } from 'react-router-dom';

export default function TestDemo() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">🧪 Test Demo</h1>
        <p className="text-gray-600 mb-4">
          This is a simple test to verify routing is working.
        </p>
        <Link 
          to="/" 
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}